import React from 'react';
import {DialogTypes} from 'common/names';
import {ConfirmationDialog} from 'components/dialogs/ConfirmationDialog';
import Typography from '@mui/material/Typography';
import {useTranslation} from 'react-i18next';
import {KeyPairType, KeyPairTypeUnion} from 'types/diplomat/enums/KeyPairType';

type OpenPgpKeyCreationProps = {
   data: {
      algorithm: KeyPairTypeUnion;
   };
   onClose: (status?: boolean) => void;
};

const OpenPgpSubKeyCreation = ({data, onClose}: OpenPgpKeyCreationProps) => {
   const {t} = useTranslation();

   return (
      <ConfirmationDialog
         title={DialogTypes.OpenPGPSubKeyCreation.dialogName}
         confirmLabel={t('Yes')}
         cancelLabel={t('No')}
         content={
            data.algorithm === KeyPairType.enum.DSA ? (
               <>
                  <Typography>
                     {t('A valid encryption subkey is required for encryptions/decryption files.')}
                  </Typography>
                  <Typography>{t('Do you want to add encryption subkeys to this key?')}</Typography>
               </>
            ) : (
               <Typography>
                  {t('Do you want to add encryption subkeys to this key now?')}
               </Typography>
            )
         }
         onCancel={() => onClose(false)}
         onOk={() => onClose(true)}
      />
   );
};

export default OpenPgpSubKeyCreation;
